import slice from "./apiSlice";

export default slice.reducer;
